<template>
    <div class="container">
        <loader :active="loading" />

        <header class="jumbotron">
            <div class="info">
                <div class="info-head"><font-awesome-icon icon="users" />
                    <h3>Zarządzanie użytkownikami</h3></div>
                <small>Poniżej możesz zobaczyć kto należy do Twojej grupy oraz usunąć użytkowników.</small>
            </div>

            <refresh :func="refresh"/>
        </header>

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h5> Użytkownicy </h5>
                    </div>

                    <div class="card-body">
                        <v-client-table :data="clients" :columns="columns" :options="options">
                            <div slot="options" slot-scope="props">
                                <button class="btn btn-danger" v-if="$route.meta.adminManage || props.row.dbid != currentUser.dbid && props.row.dbid != premiumChannel.ownerDbid" @click="deleteClient(props.row.dbid)">Usuń ze strefy</button>
                                <button class="btn btn-warning" v-if="props.row.botAccess == 1" @click="deleteBotAccessGroup(props.row.dbid)">Zabierz dostęp do bota</button>
                                <button class="btn btn-success" v-if="props.row.botAccess == 0" @click="addBotAccessGroup(props.row.dbid)">Daj dostęp do bota</button>
                            </div>
                            <div slot="status" slot-scope="props"><span v-if="props.row.status == 'AFK'" class="badge badge-warning">{{ props.row.status }}</span><span v-else-if="props.row.status == 'Online'" class="badge badge-success">{{ props.row.status }}</span><span v-else class="badge badge-danger">{{ props.row.status }}</span></div>
                            <ul v-if="props.row.channel" slot="channel" slot-scope="props" class="ts-channel"><channel :channel="props.row.channel" :clickable="false" /></ul>
                            <span v-else> --- </span>
                            <client slot="nick" slot-scope="props" :client="props.row"/>
                            <span slot="lastConnected" slot-scope="props">{{ props.row.lastConnected | moment("DD-MM-YYYY HH:mm:ss")}}</span>
                        </v-client-table>
                    </div>

                    <div class="card-footer">
                        <button v-if="$route.meta.adminManage || premiumChannel.ownerDbid == currentUser.dbid" @click="deleteAll" class="btn btn-danger"><font-awesome-icon icon="exclamation-triangle"/> Czystka</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ClientsService from '../services/clients.service';
    import Vue from "vue";

    export default {
        name: 'Clients',
        data() {
            return {
                loading: true,
                clients: [],
                clientsData: [],
                columns: ['dbid', 'nick', 'status', 'channel', 'lastConnected', 'options'],
                options: {
                    headings: {
                        dbid: 'Dbid',
                        nick: 'Nick',
                        status: 'Status',
                        channel: 'Kanał',
                        lastConnected: 'Ostatnie połączenie',
                        options: 'Opcje',
                    },
                    sortable: ['dbid', 'nick', 'status', 'lastConnected'],
                    filterable: ['dbid', 'nick', 'status'],
                    texts: window.vueTableLocalize,
                },
            };
        },
        mounted() {
            this.refresh();
        },
        computed: {
            currentUser() {
                return this.$store.state.auth.user;
            },
            premiumChannel() {
                return this.$store.state.auth.premiumChannel;
            },
        },
        methods: {
            refresh() {
                this.loading = true;

                ClientsService.getClients().then(
                    response => {
                        this.clients = response.data.clients;
                        this.loading = false;
                    },
                    error => {
                        this.loading = false;
                        console.log(error)
                    }
                );
            },
            deleteClient(dbid) {
                Vue.swal.fire({
                    title: 'Jesteś pewny?',
                    text: "Nie będziesz mógł cofnąć tej operacji!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Tak, usuń!',
                    cancelButtonText: 'Anuluj'
                }).then((result) => {
                    if (result.value) {
                        this.loading = true;

                        ClientsService.deleteClient(dbid).then(
                            () => {
                                this.refresh();

                                Vue.swal.fire({
                                    title: 'Usunięto klienta!',
                                    icon: 'success',
                                    timer: 1000,
                                    showConfirmButton: false,
                                });
                            },
                            error => {
                                this.loading = false;
                                console.log(error)
                            }
                        );
                    }
                });
            },
            deleteAll() {
                Vue.swal.fire({
                    title: 'Jesteś pewny?',
                    text: "Nie będziesz mógł cofnąć tej operacji! Wszystkie osoby z grupy z wyjątkiem Ciebie zostaną usunięte!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Tak, usuń!',
                    cancelButtonText: 'Anuluj'
                }).then((result) => {
                    if (result.value) {
                        this.loading = true;

                        ClientsService.deleteAll().then(
                            () => {
                                this.refresh();

                                Vue.swal.fire({
                                    title: 'Przeprowadzono czystkę',
                                    icon: 'success',
                                    timer: 1000,
                                    showConfirmButton: false,
                                });
                            },
                            error => {
                                this.loading = false;
                                console.log(error)
                            }
                        );
                    }
                });
            },
            deleteBotAccessGroup(dbid) {
                Vue.swal.fire({
                    title: 'Jesteś pewny?',
                    text: "Nie będziesz mógł cofnąć tej operacji!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Tak, zabierz!',
                    cancelButtonText: 'Anuluj'
                }).then((result) => {
                    if (result.value) {
                        this.loading = true;

                        ClientsService.deleteBotAccessGroup(dbid).then(
                            () => {
                                this.refresh();

                                Vue.swal.fire({
                                    title: 'Usunięto dostęp do bota!',
                                    icon: 'success',
                                    timer: 1000,
                                    showConfirmButton: false,
                                });
                            },
                            error => {
                                this.loading = false;
                                console.log(error)
                            }
                        );
                    }
                });
            },
            addBotAccessGroup(dbid) {
                Vue.swal.fire({
                    title: 'Jesteś pewny?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Tak, nadaj!',
                    cancelButtonText: 'Anuluj'
                }).then((result) => {
                    if (result.value) {
                        this.loading = true;

                        ClientsService.addBotAccessGroup(dbid).then(
                            () => {
                                this.refresh();

                                Vue.swal.fire({
                                    title: 'Dodano dostęp do bota!',
                                    icon: 'success',
                                    timer: 1000,
                                    showConfirmButton: false,
                                });
                            },
                            error => {
                                this.loading = false;
                                console.log(error)
                            }
                        );
                    }
                });
            }
        }
    };
</script>

<style>
    .ts-channel {
        list-style: none;
        padding-inline-start: 0px;
    }
</style>